// Seasonal appearance from the user's current real-world month.
// Canopy stays green-dominant year-round (green oak foliage); only deep winter goes bare.
export function getSeason() {
  const m = new Date().getMonth(); // 0-11
  if (m <= 1 || m === 11) return { canopy: "#3f6b2e", bare: true, name: "winter" };
  if (m >= 2 && m <= 4) return { canopy: "#4c7a34", bare: false, name: "spring" };
  if (m >= 5 && m <= 7) return { canopy: "#3f6b2e", bare: false, name: "summer" };
  return { canopy: "#5b7a2e", bare: false, name: "autumn" };
}
